export default [
  {
    primaryTitle: 'Meditation for Suburbbrain',
    year: '2011',
   
    description: require('./room1/content.md'),
    image: require('./room1/vorstadthirn-ohne-spruch.jpg'),
    imagePosition: 'bottom center',
    audio: [
      {
        mp3: require('./room1/audio1/01_MCA Meditation for Suburb Brain.mp3'),
        ogg: require('./room1/audio1/01_MCA-Meditation-for-Suburb-Brain.ogg'),
        description: require('./room1/audio1/small_suburb_brain_description.md'),
        image: require('./room1/audio1/Meditation for Suburb Brain.jpg'),
        imagePosition: 'top center',
        captions: require('./room1/audio1/01_MCA Meditation for Suburb Brain.js'),
      },
      
    ],
    auslan: '239586858',
    room: '1',
  },

  {
    primaryTitle: 'Sip My Ocean',
    year: '1996',
    description: require('./room2/content.md'),
    image: require('../images/works/sip-new-105-cmyk_square.jpg'),
    imagePosition: 'right bottom',
    audio: [
      {
        mp3: require('./room2/audio1/02_1MCA Sip My Ocean.mp3'),
        ogg: require('./room2/audio1/02_1MCA-Sip-My-Ocean.ogg'),
        description: require('./room2/audio1/sipmyocean.md'),
        image: require('../images/works/sip-new-105-cmyk_square.jpg'),
        imagePosition: 'bottom center',
        primaryTitle: 'Sip My Ocean',
        year: '1996',
        captions: require('./room2/audio1/02_1MCA Sip My Ocean.js'),
      },
      {
        mp3: require('./room2/audio2/02_2_MCA Ever Is Over All.mp3'),
        ogg: require('./room2/audio2/02_2_MCA-Ever-Is-Over-All.ogg'),
        description: require('./room2/audio2/ever_is_over.md'),
        image: require('../images/works/ever_is_over.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Ever is Over All',
        year: '1997',
        captions: require('./room2/audio2/02_2_MCA Ever Is Over All.js'),
      },
    ],
    auslan: '239586835',
    room: '2',
  },

  {
    primaryTitle: 'Das Zimmer (The Room)',
    year: '1994/2017',
    description: require('./room3/content.md'),
    image: require('./room3/audio2/das_zimmer_holder.jpg'),
    imagePosition: 'center center',
    audio: [
      {
        mp3: require('./room3/audio2/03_2MCA Das Zimmer.mp3'),
        ogg: require('./room3/audio2/03_2MCA-Das-Zimmer.ogg'),
        description: require('./room3/audio2/content.md'),
        image: require('./room3/audio2/das_zimmer_holder.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Das Zimmer (The Room)',
        year: '1994/2017',
        captions: require('./room3/audio2/03_2MCA Das Zimmer.js'),
      },
      {
        mp3: require('./room3/audio3/03_3MCA Pickle Porrno.mp3'),
        ogg: require('./room3/audio3/03_3MCA-Pickle-Porrno.ogg'),
        description: require('./room3/audio3/content.md'),
        image: require('./room3/audio3/PICKELPORNO_holder.jpg'),
        imagePosition: 'right top',
        primaryTitle: 'Pickelporno (Pimple Porno)',
        year: '1992',
        captions: require('./room3/audio3/03_3MCA Pickle Porrno.js'),
      },
      {
        mp3: require('./room3/audio4/03_4MCA Open My Glade.mp3'),
        ogg: require('./room3/audio4/03_4MCA-Open-My-Glade.ogg'),
        description: require('./room3/audio4/content.md'),
        image: require('./room3/audio4/open_my_glade_holder.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Open my Glade',
        year: 1997,
        captions: require('./room3/audio4/03_4MCA Open My Glade.js'),
      },
      {
        mp3: require('./room3/audio1/03_1MCA Mutoflor.mp3'),
        ogg: require('./room3/audio1/03_1MCA-Mutoflor.ogg'),
        description: require('./room3/audio1/content.md'),
        image: require('./room3/audio1/mutaflor_holder.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Mutaflor',
        year: '1996',
        captions: require('./room3/audio1/03_1MCA-Mutoflor.js'),
      },
      {
        mp3: require('./room3/audio5/03_5MCA Im Not The Girl Who Misses Much.mp3'),
        ogg: require('./room3/audio5/03_5MCA-I_m-Not-The-Girl.ogg'),
        description: require('./room3/audio5/content.md'),
        image: require('./room3/audio5/RIST-15-not-the-girl.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Im Not The Girl Who Misses Much',
        year: '1996',
        captions: require('./room3/audio5/03_5MCA Im Not The Girl Who Misses Much.js'),
      },
    ],
    auslan: '239588073',
    room: '3',
  },

  {
    primaryTitle: 'Administrating Eternity',
    year: 2011,
    description: require('./room4/content.md'),
    image: require('../images/works/administering-eternity-2011.jpg'),
    imagePosition: 'center center',
    audio: [
      {
        mp3: require('./room4/audio1/04_MCA Administrating Eternity.mp3'),
        ogg: require('./room4/audio1/04_MCA-Administrating-Eternity.ogg'),
        description: require('./room4/audio1/content.md'),
        image: require('./room4/audio1/administering-eternity-2011.jpg'),
        captions: require('./room4/audio1/04_MCA Administrating Eternity.js'),
      },
    ],    
    auslan: '239588056',
    room: '4',
  },

  {
    primaryTitle: 'Pixelwald Motherboard (Pixel Forest Mutterplatte)',
    year: '2016',
    description: require('./room5/content.md'),
    image: require('../images/works/one_page_slide_Pixel-Forest-2016.jpg'),
    audio: [
      {
        mp3: require('./room5/audio1/05_MCA Pixelworld.mp3'),
        ogg: require('./room5/audio1/05_MCA-Pixelworld.ogg'),
        description: require('./room5/audio1/content.md'),
        image: require('./room5/audio1/one_page_slide_Pixel-Forest-2016.jpg'),
        imagePosition: 'center center',
        captions: require('./room5/audio1/05_MCA Pixelworld.js'),
      },
    ],
   
     auslan: '239586755',

    room: '5',
  },

  {
    primaryTitle: 'A la belle étoile (Under The Sky)',
    year: '2007',
    description: require('./room6/content.md'),
    image: require('./room6/audio1/06_a-la-belle-etoile_room.jpg'),
    audio: [
      {
        mp3: require('./room6/audio1/06_MCA A La Belle Etoile.mp3'),
        ogg: require('./room6/audio1/06_MCA-A-La-Belle-Etoile.ogg'),
        description: require('./room6/audio1/content.md'),
        image: require('./room6/audio1/06_a-la-belle-etoile_room.jpg'),
        imagePosition: 'center center',
        captions: require('./room6/audio1/06_MCA A La Belle Etoile.js'),
      },
    ],
    auslan: '239586781',
    room: '6',
  },

  {
    primaryTitle: 'Sleeping Pollen',
    year: '2014',
    description: require('./room7/content.md'),
    image: require('./room7/RIST65168-1_RIST-65168.jpg'),
    audio: [],
    auslan: '239588042',
    room: '7',
  },

  {
    primaryTitle: 'Your Room Opposite the Opera',
    year: "1994-2017",
    description: require('./room8/content.md'),
    image: require('./room8/audio5/apartment.jpg'),
    imagePosition: 'center right',
    audio: [
       {
        mp3: require('./room8/audio5/08_5MCA The Apartment.mp3'),
        ogg: require('./room8/audio5/08_5MCA-The-Apartment.ogg'),
        description: require('./room8/audio5/content.md'),
        image: require('./room8/audio5/apartment.jpg'),
        imagePosition: 'center right',
        primaryTitle: 'Your Room Opposite the Opera',
        year: '1994-2017',
        captions: require('./room8/audio5/08_5MCA The Apartment.js'),
      },
      
      {
        mp3: require('./room8/audio1/08_MCA Selfless in the Bath Of Lava.mp3'),
        ogg: require('./room8/audio1/08_MCA-Selfless-in-the-Bath-Of-Lava.ogg'),
        description: require('./room8/audio1/content.md'),
        image: require('./room8/audio1/pr5.jpg'),
        imagePosition: 'bottom right',
        primaryTitle: 'Selfless in the Bath Of Lava',
        year: '1994-2017',
        captions: require('./room8/audio1/08_MCA Selfless in the Bath Of Lava.js'),
      },
     
      {
        mp3: require('./room8/audio2/08_2MCA Cape Cod Chandelier.mp3'),
        ogg: require('./room8/audio2/08_2MCA-Cape-Cod-Chandelier.ogg'),
        description: require('./room8/audio2/content.md'),
        image: require('./room8/audio2/3rd-FLOOR_VIEW-4_B.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Cape Cod Chandelier',
        year: '2011',
        captions: require('./room8/audio2/08_2MCACapeCodChandelier.js'),
      },
{
        mp3: require('./room8/audio3/08_3MCA Upside Down Table.mp3'),
        ogg: require('./room8/audio3/08_3MCA-Upside-Down-Table.ogg'),
        description: require('./room8/audio3/content.md'),
        image: require('./room8/audio3/DSC_4117.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Upside Down Table',
        year: '2011',
        captions: require('./room8/audio3/08_3MCA Upside Down Table.js'),
      },
      
      {
        mp3: require('./room8/audio4/08_4MCA Deine Raumkapsel.mp3'),
        ogg: require('./room8/audio4/08_4MCA-Deine-Raumkapsel.ogg'),
    description: require('./room8/audio4/content.md'),
        image: require('./room8/audio4/516138_original.jpg'),
        imagePosition: 'center center',
        primaryTitle: 'Deine Raumkapsel',
        year: '2006',
        captions: require('./room8/audio4/08_4MCA Deine Raumkapsel.js'),
      },
      
     
      {
        mp3: require('./room8/audio6/08_6MCA Another Body.mp3'),
        ogg: require('./room8/audio6/08_6MCA-Another-Body.ogg'),
        description: require('./room8/audio6/content.md'),
        image: require('./room8/audio6/Lungenflugel.jpg'),
        imagePosition: 'bottom left',
        primaryTitle: 'Another Body',
        year: '2009',
          captions: require('./room8/audio6/08_6MCA Another Body.js'),
      },

    ],
     auslan: '239586756',
       room: '8',
  },

  {
    primaryTitle: '4th Floor to Mildness',
    year: '2016',
    description: require('./room9/content.md'),
    image: require('./room9/4th-FLOOR_VIEW-6_SCALE-A_square.jpg'),
    imagePosition: 'top center',
    audio: [
      {
        mp3: require('./room9/audio1/09_MCA 4th Floor to Mildness.mp3'),
        ogg: require('./room9/audio1/09_MCA-4th-Floor-to-Mildness.ogg'),
        description: require('./room9/audio1/content.md'),
        captions: require('./room9/audio1/09_MCA 4th Floor to Mildness.js'),
      },
    ],
    auslan: '239586771',
    room: '9',
  },

  {
    primaryTitle: 'In conversation with MCA Young Guides',
    year: 2017,
    description: require('./room10/content.md'),
    image: require('./room10/audio1/pipilotti_yc_audio05.jpg'),
    audio: [
	    {
        mp3: require('./room10/audio1/10_conversation.mp3'),
        ogg: require('./room10/audio1/10_conversation.ogg'),
        description: require('./room10/audio1/content.md'),
        captions: require('./room10/audio1/10_conversation_srt.js'),
      },

    ],
  },
]



// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/index.js